import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../utilities/axiosInstance";

const initialState = {
  isLoading: false,
  data: [],
  itemsCount: 0,
  pages: 0,
  error: null,
};

export const getWallet = createAsyncThunk(
  "wallet/getWallet",
  async (args, thunkApi) => {
    try {
      const { page = 1, size = 10, owner, query, filter = {}, action, referenceModel } = args || {};

      // Build query parameters
      const params = new URLSearchParams();
      params.append("page", page);
      params.append("size", size);

      if (owner) params.append("owner", owner);
      if (query) params.append("query", query);
      if (action) params.append("action", action);
      if (referenceModel) params.append("referenceModel", referenceModel);

      // Add filter parameters
      Object.keys(filter).forEach(key => {
        if (filter[key] !== undefined && filter[key] !== null && filter[key] !== '') {
          params.append(key, filter[key]);
        }
      });

      const { data } = await axiosInstance.get(`/wallet?${params.toString()}`);
      return thunkApi.fulfillWithValue(data);
    } catch (e) {
      return thunkApi.rejectWithValue(e.response?.data || { message: "error" });
    }
  }
);

export const giftWallet = createAsyncThunk(
  "wallet/giftWallet",
  async (args, thunkApi) => {
    try {
      const { data } = await axiosInstance.post(`/wallet/gift`, args);
      return thunkApi.fulfillWithValue(data);
    } catch (e) {
      return thunkApi.rejectWithValue(e.response?.data || { message: "error" });
    }
  }
);

export const getGiftedWallet = createAsyncThunk(
  "wallet/getGiftedWallet",
  async (args, thunkApi) => {
    try {
      const { page = 1, size = 10, owner, ...rest } = args || {};

      const params = new URLSearchParams();
      params.append("page", page);
      params.append("size", size);

      if (owner) params.append("owner", owner);
      params.append("action", "GIFT");

      Object.entries(rest).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
          params.append(key, value);
        }
      });

      const { data } = await axiosInstance.get(`/wallet?${params.toString()}`);
      return thunkApi.fulfillWithValue(data);
    } catch (e) {
      return thunkApi.rejectWithValue(e.response?.data || { message: "error" });
    }
  }
);

const newWalletSlice = createSlice({
  name: "newWallet",
  initialState,
  reducers: {
    resetNewWalletState: () => initialState,
  },
  extraReducers: (b) => {
    b.addCase(getWallet.pending, (s) => {
      s.isLoading = true;
      s.error = null;
    })
      .addCase(getWallet.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.error = null;
        state.data = payload?.data?.data || [];
        state.itemsCount = Number(payload?.data?.itemsCount) || 0;
        state.pages = Number(payload?.data?.pages) || 0;
      })
      .addCase(getWallet.rejected, (s, { payload }) => {
        s.isLoading = false;
        s.error = payload?.message;
      })

      .addCase(giftWallet.pending, (s) => {
        s.isLoading = true;
        s.error = null;
      })
      .addCase(giftWallet.fulfilled, (s) => {
        s.isLoading = false;
      })
      .addCase(giftWallet.rejected, (s, { payload }) => {
        s.isLoading = false;
        s.error = payload?.message;
      })

      .addCase(getGiftedWallet.pending, (s) => {
        s.isLoading = true;
        s.error = null;
      })
      .addCase(getGiftedWallet.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.error = null;
        state.data = payload?.data?.data || [];
        state.itemsCount = Number(payload?.data?.itemsCount) || 0;
        state.pages = Number(payload?.data?.pages) || 0;
      })
      .addCase(getGiftedWallet.rejected, (s, { payload }) => {
        s.isLoading = false;
        s.error = payload?.message;
      });
  },
});

export const { resetNewWalletState } = newWalletSlice.actions;
export default newWalletSlice.reducer;
